<nav><div class="hidePrint">
  <button mat-icon-button [matMenuTriggerFor]="mainMenu">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #mainMenu="matMenu">
    <button mat-menu-item (click)="newChar()"><mat-icon>person_add</mat-icon>New character</button>
    <button mat-menu-item routerLink="feast"><mat-icon>nightlife</mat-icon>Feast</button>
    <button mat-menu-item routerLink="arms"><mat-icon>shield</mat-icon>Coat of Arms</button>
    <button mat-menu-item (click)="openChangelog()"><mat-icon>history</mat-icon>Changelog</button>
  </mat-menu>
  <button mat-button [matMenuTriggerFor]="players">
    <mat-icon>local_police</mat-icon>
    Players
  </button>
  <mat-menu #players="matMenu">
    @for (c of list; track c) {
      @if (isPc(c)) {
        <button mat-menu-item routerLink="character/{{c.name}}">
          <mat-icon >security</mat-icon>
          {{c.name}}
        </button>
      }
    }
  </mat-menu>
  <button mat-button (click)="openAll()"><mat-icon>switch_account</mat-icon>All</button>
  @if (isLoggedIn()) {
    <button mat-button [matMenuTriggerFor]="myChars"><mat-icon>account_circle</mat-icon>MyCharacters</button>
  }
  <mat-menu #myChars="matMenu">
    @for (c of myCharacters(); track c) {
      <button mat-menu-item routerLink="character/{{c.name}}" [class.active-char]="isActive(c)">
        <mat-icon>{{isActive(c) ? 'star' : 'star_border'}}</mat-icon>
        <span>{{c.name}}</span>
      </button>
    }
  </mat-menu>
  <button mat-button routerLink="team">
    <mat-icon>groups</mat-icon>
    Team
  </button>
  <button mat-button routerLink="rolls">
    <mat-icon>casino</mat-icon>
    Rolls
  </button>
  <button mat-button routerLink="maps">
    <mat-icon>map</mat-icon>
    Maps
  </button>
  <span class="spacer"></span>
  @if (!hasToken()) {
    <button mat-button (click)="loginWithDiscord()"><mat-icon>login</mat-icon>Login with Discord</button>
  }
  @if (hasToken()) {
    <button mat-button (click)="logout()"><mat-icon>logout</mat-icon>Logout</button>
  }
  @if (isLoggedIn()) {
    <span class="user-name">{{user.name}}</span>
  }
  </div><div></div>
</nav>
<router-outlet></router-outlet>
<app-messages></app-messages>
